import React from 'react';
import ReactMarkdown from 'react-markdown'
import filePathGeneral from './markdownContents/general.md';
import filePathMusic from './markdownContents/music.md';
import filePathContact from './markdownContents/contact.md';


class App extends React.Component {
    constructor() {
        super();
        this.state = {
            markdownGeneral: '',
            markdownMusic: '',
            markdownContact: ''
        };
    }
    componentDidMount() {
        // Get the contents from the Markdown file and put them in the React state, so we can reference it in render() below.
        fetch(filePathGeneral).then(res => res.text()).then(text => this.setState({ markdownGeneral: text }));
        fetch(filePathMusic).then(res => res.text()).then(text => this.setState({ markdownMusic: text }));
        fetch(filePathContact).then(res => res.text()).then(text => this.setState({ markdownContact: text }));
    }
    render() {
        const { markdownGeneral, markdownMusic, markdownContact } = this.state;
        const contentsNumber = this.props.contentsNumber;
        let markdown;
        if (contentsNumber === 0) {
            markdown = markdownGeneral;
        } else if (contentsNumber === 1){
            markdown = markdownMusic;
        } else {
            markdown = markdownContact;
        }
        return (
            <ReactMarkdown source={ markdown } />
        )
    }
}

export default App;